export default __webpack_public_path__ + "src/docs/packages/the-african-renaissance.pdf";